import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SubscriptionComponent } from '../../modules/chargebee/subscription/subscription.component';
import { AuthService } from '../../modules/auth/services/auth.service';
import { UserService } from '../../core/services/user.service';
import { SettingService } from '../../core/services/setting.service';
import { ChargebeeService } from '../../core/services/chargebee.service';
import { SETTINGS } from '../../core/config/common.settings';
import * as moment from 'moment';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslocoService } from '@ngneat/transloco';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  year = moment().startOf('year').year();
  user: any;
  loggedUser: any;
  organizationSetting: any;

  protected version = SETTINGS.VERSION;
  protected readonly SETTINGS = SETTINGS;
  isSubUrl = false;
  statusObj: { text: string; status: string; plan: string } = {
    text: 'processing',
    status: 'Processing',
    plan: ''
  };

  readonly availableLanguages: { code: string; labelKey: string }[] = [
    { code: 'en', labelKey: 'languages.en' },
    { code: 'ru', labelKey: 'languages.ru' },
    { code: 'es', labelKey: 'languages.es' },
    { code: 'de', labelKey: 'languages.de' },
  ];

  activeLang: string = 'en';

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private settingService: SettingService,
    private chargebeeService: ChargebeeService,
    private router: Router,
    private translocoService: TranslocoService,
    private message: NzMessageService,
    private modalService: NzModalService,
  ) {
    this.loggedUser = this.authService.getLoggedInUser();
    this.activeLang = this.translocoService.getActiveLang();
  }

  ngOnInit(): void {
    this.getSubscriptionInfo();
    this.userService.getUserByIDToHeader(this.loggedUser.userId);
    this.userService.onLoggedInUserChange.subscribe((user: any) => {
      this.user = user
      if (user?.[0]?.appLanguage && user[0]?.appLanguage !== this.activeLang) {
        this.activeLang = user[0].appLanguage;
        this.translocoService.setActiveLang(user[0].appLanguage);
      }
    });
    this.settingService.findBrand(this.loggedUser.userId);
    this.settingService.onBrandChange.subscribe((brand: any) => {
      this.organizationSetting = brand;
      if (this.user?.[0]?.appLanguage && this.user[0]?.appLanguage !== this.activeLang) {
        this.activeLang = this.user[0].appLanguage;
        this.translocoService.setActiveLang(this.user[0].appLanguage);
      }
    });

    this.checkUrl(this.router.url);
    // check on url changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.checkUrl(event.urlAfterRedirects);
      });
  }

  async logout(): Promise<any> {
    await this.authService.logout();
  }

  async changeLanguage(langCode: string): Promise<void> {
    this.activeLang = langCode;
    this.translocoService.setActiveLang(langCode);


    try {
      await this.userService.editUser({
        _id: this.loggedUser.userId,
        appLanguage: langCode,
      });
      this.message.success(this.translocoService.translate('user.messages.languagePreferenceSaved'));
    } catch {
      this.message.error(this.translocoService.translate('user.messages.languagePreferenceFailed'));
    }
  }
  profilePlaceHolder(): string {
    return (
      'https://avatars.dicebear.com/api/micah/' + this.user[0]?.email + '.svg'
    );
  }

  private checkUrl(url: string): void {
    this.isSubUrl = url.includes('/payment');
  }

  async getSubscriptionInfo(): Promise<void> {
    try {
      this.statusObj = await this.chargebeeService.getSubscriptionInfo();
    } catch (error) {
      console.error('Failed to get subscription info:', error);
      throw error;
    }
  }

  getPillClass(status: string) {
    return {
      trial: status === 'in_trial',
      active: status === 'active',
      cancelled: status === 'cancelled',
      processing: status === 'processing'
    };
  }

  openUpgradeModal(): void {
    const modal = this.modalService.create({
      nzContent: SubscriptionComponent,
      nzWidth: '900px',
      nzFooter: null,
      nzCentered: true,
      nzClosable: false,
    });

    const instance = modal.getContentComponent();
    instance.isUpgrade = true;

    modal.afterClose.subscribe((result: string) => {
      if (result === 'upgraded') {
        this.ngOnInit();
      }
    });
  }

  goToBilling() {
    this.router.navigate(['/admin/settings'], {
      queryParams: { tab: 'billing' }
    });
  }

}
